export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header.vue?vue&type=template&id=8930d902&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/header.vue?vue&type=template&id=8930d902&
// module id = 260
// module chunks = 30